module.exports = __webpack_public_path__ + "img/Indonesia-10.843f445d.jpg";